import React from 'react';

import fullBodySVG from '@/assets/svg/human_body/full_body.svg';
import headSVG from '@/assets/svg/human_body/head.svg';
import neckSVG from '@/assets/svg/human_body/neck.svg';
import trunkSVG from '@/assets/svg/human_body/trunk.svg';
import hipSVG from '@/assets/svg/human_body/hip.svg';

import leftUpperArmSVG from '@/assets/svg/human_body/left_upper_arm.svg';
import leftLowerArmSVG from '@/assets/svg/human_body/left_lower_arm.svg';
import leftWristSVG from '@/assets/svg/human_body/left_wrist.svg';
import rightUpperArmSVG from '@/assets/svg/human_body/right_upper_arm.svg';
import rightLowerArmSVG from '@/assets/svg/human_body/right_lower_arm.svg';
import rightWristSVG from '@/assets/svg/human_body/right_wrist.svg';

import leftLegSVG from '@/assets/svg/human_body/left_leg.svg';
import rightLegSVG from '@/assets/svg/human_body/right_leg.svg';

import {
	Container,
	BodyImage,
	BodyPart,
	colorsRiskDegree,
	originalImageSize,
	partFactors
} from './styles';

const bodyParts = {
	head: {
		image: headSVG,
		color: null,
		enable: false
	},
	neck: {
		image: neckSVG,
		color: null,
		enable: true
	},
	trunk: {
		image: trunkSVG,
		color: null,
		enable: true
	},
	hip: {
		image: hipSVG,
		color: null,
		enable: false
	},
	left_upper_arm: {
		image: leftUpperArmSVG,
		color: null,
		enable: true
	},
	left_lower_arm: {
		image: leftLowerArmSVG,
		color: null,
		enable: true
	},
	left_wrist: {
		image: leftWristSVG,
		color: null,
		enable: false
	},
	right_upper_arm: {
		image: rightUpperArmSVG,
		color: null,
		enable: true
	},
	right_lower_arm: {
		image: rightLowerArmSVG,
		color: null,
		enable: true
	},
	right_wrist: {
		image: rightWristSVG,
		color: null,
		enable: false
	},
	left_knee: {
		image: leftLegSVG,
		color: null,
		enable: true
	},
	right_knee: {
		image: rightLegSVG,
		color: null,
		enable: true
	}
};

const riskLabels = ['not_identified', 'safe', 'info', 'warning', 'danger'];

export const HumanBody = ({ height, onSelect, selectedPartName, bodyPartScores }) => {
	let isSelected = Object.keys(bodyParts).includes(selectedPartName);

	for (const key of Object.keys(bodyPartScores)) {
		for (let risk_index = riskLabels.length - 1; risk_index >= 0; risk_index--) {
			if (bodyPartScores[key][risk_index] > 0) {
				bodyParts[key].color = colorsRiskDegree[riskLabels[risk_index]];
				break;
			}
		}
	}

	const onClickBodyPart = (e) => {
		const bodyPart = e.currentTarget.id;
		onSelect(bodyPart);
	};

	const width = (height / 2200) * originalImageSize.width;

	return (
		<Container>
			<BodyImage id="full-body" src={fullBodySVG} alt="" style={{ height }} />
			{Object.entries(bodyParts).map(([partName, part]) => {
				let selectedClassName = '';
				const disabledClassName = !part.enable ? 'disabled' : '';
				if (isSelected) {
					selectedClassName =
						partName === selectedPartName ? 'selected' : 'unselected';
				}

				return (
					<BodyPart
						key={partName}
						className={[disabledClassName, selectedClassName].join(' ')}
						id={partName}
						src={part.image}
						color={part.color}
						factors={partFactors[partName]}
						onClick={onClickBodyPart}
						height={height}
						width={width}
					/>
				);
			})}
		</Container>
	);
};
